import React from 'react'
import IntroParagraph from "../components/IntroParagraph";
import Link from 'gatsby-link'

export default () => (
  <div>
    <IntroParagraph />

    <h1>Coming Soon</h1>

    <p>Currently the only set of learning resources (Apps, book, quiz, resources) is Elm Accelerated. But I have ideas
      for other topics such as <em>Data in/for React</em> and <em>GLSL</em>.</p>

    <Link to="/elm" className="main-button elm-bg">Elm Accelerated: Quiz, sample chapters and resources on Elm</Link>

    <Link to="/typescript" className="main-button elm-bg">TypeScript Accelerated: sample chapters and resources on TypeScript</Link>
  </div>
);



// WEBPACK FOOTER //
// ./src/pages/soon.js